// IHGIND - Real Company Data

export const siteConfig = {
  name: "IHG Industry",
  tagline: "Engineering Precision. Artistic Vision.",
  subline: "Premium architectural metal fabrication and artistic metalwork for visionary architects, designers, and artists.",
  motto: "Design. Engineer. Fabricate. Create.",
  phone: "+971 4 258 5754",
  mobile: "+971 55 991 0711",
  email: "info@ihgind.com",
  address: "Jebel Ali Industrial Area 1, Dubai, UAE",
  whatsapp: "971559910711",
  parentCompany: "IHG Brands",
  parentUrl: "https://ihgbrands.com",
  website: "https://ihgind.com",
};

// Unified Navigation - Mega Menu Structure
export const navLinks = [
  { 
    label: "Capabilities", 
    href: "/capabilities",
    children: [
      { label: "Architectural Facades", href: "/capabilities/architectural-metal-facades", description: "Perforated systems, parametric screens, cladding" },
      { label: "Interior Metalwork", href: "/capabilities/interior-metal-decor", description: "Feature walls, ceilings, decorative elements" },
      { label: "Specialist Finishes", href: "/capabilities/special-metal-finishes", description: "PVD, electroplating, patina treatments" },
      { label: "CNC & Laser Cutting", href: "/capabilities/cnc-laser-cutting", description: "Precision fabrication & profiling" },
      { label: "Signage & Displays", href: "/capabilities/signage-integration", description: "Custom signage, retail displays" },
      { label: "View All Capabilities", href: "/capabilities", featured: true },
    ]
  },
  { 
    label: "Studio", 
    href: "/studio-works",
    children: [
      { label: "Architectural Installations", href: "/studio-works/architectural", description: "Landmark facades & building expressions" },
      { label: "Interior Expressions", href: "/studio-works/interiors", description: "Sculptural elements & feature metalwork" },
      { label: "Art Atelier", href: "/art-atelier", description: "Sculptures & artist collaborations" },
      { label: "Retail & Brand", href: "/studio-works/retail", description: "Luxury retail & brand environments" },
      { label: "divider", divider: true },
      { label: "The Screen Collection", href: "/collections/screens", description: "Geometric perforated screens" },
      { label: "The Light Series", href: "/collections/light", description: "Backlit metal installations" },
      { label: "The Sculpt Series", href: "/collections/sculpt", description: "Sculptural metal forms" },
      { label: "divider", divider: true },
      { label: "Studio Collaborate", href: "/studio-collaborate", description: "Partner with our design studio", featured: true },
    ]
  },
  { 
    label: "Projects", 
    href: "/portfolio",
    children: [
      { label: "All Projects", href: "/portfolio", description: "Featured project documentation" },
      { label: "divider", divider: true },
      { label: "Hospitality", href: "/portfolio?category=Hospitality", description: "Hotels, resorts & serviced apartments" },
      { label: "Commercial", href: "/portfolio?category=Commercial", description: "Office towers & corporate spaces" },
      { label: "Retail & F&B", href: "/portfolio?category=Retail", description: "Stores, restaurants & branded spaces" },
      { label: "Residential", href: "/portfolio?category=Luxury Residential", description: "Villas, palaces & private residences" },
      { label: "Healthcare", href: "/portfolio?category=Healthcare", description: "Hospitals & medical facilities" },
      { label: "Cultural", href: "/portfolio?category=Cultural", description: "Museums, mosques & public buildings" },
    ]
  },
  { 
    label: "Industries", 
    href: "/industries",
    children: [
      { label: "For Architects", href: "/industries/architects", description: "Design partnership & technical support" },
      { label: "For Interior Designers", href: "/industries/interior-designers", description: "Bespoke finishes & custom metalwork" },
      { label: "For Contractors", href: "/industries/contractors", description: "Reliable delivery & coordination" },
      { label: "For Developers", href: "/industries/developers", description: "Value engineering & turnkey solutions" },
      { label: "divider", divider: true },
      { label: "Hospitality Sector", href: "/industries/hospitality", description: "Hotels & resorts metalwork" },
      { label: "Commercial Sector", href: "/industries/commercial", description: "Office & corporate projects" },
      { label: "Retail Sector", href: "/industries/retail", description: "Retail & F&B environments" },
      { label: "Residential Sector", href: "/industries/residential", description: "Luxury villas & residences" },
      { label: "divider", divider: true },
      { label: "View All Industries", href: "/industries", featured: true },
    ]
  },
  { 
    label: "GCC", 
    href: "/gcc/saudi-arabia",
    children: [
      { label: "Saudi Arabia", href: "/gcc/saudi-arabia", description: "Riyadh, Jeddah, NEOM" },
      { label: "Qatar", href: "/gcc/qatar", description: "Doha, Lusail, The Pearl" },
      { label: "Kuwait", href: "/gcc/kuwait", description: "Kuwait City, Salmiya" },
      { label: "Oman", href: "/gcc/oman", description: "Muscat, Salalah" },
      { label: "Bahrain", href: "/gcc/bahrain", description: "Manama, Bahrain Bay" },
      { label: "divider", divider: true },
      { label: "UAE (Home Base)", href: "/about", description: "Dubai headquarters", featured: true },
    ]
  },
  { 
    label: "Company", 
    href: "/about",
    children: [
      { label: "About Us", href: "/about", description: "Our story & capabilities" },
      { label: "Our Team", href: "/team", description: "Leadership & expertise" },
      { label: "Material Innovation", href: "/material-innovation", description: "R&D lab & research programs" },
      { label: "Quality & HSE", href: "/quality-hse", description: "ISO certifications & safety" },
      { label: "Sustainability", href: "/sustainability", description: "Environmental commitment" },
      { label: "Careers", href: "/careers", description: "Join our team" },
    ]
  },
  { 
    label: "Resources", 
    href: "/resources",
    children: [
      { label: "Estimation Tools", href: "/calculators", description: "Calculators for architects & contractors", children: [
        { label: "Area Calculator", href: "/calculators/area", description: "2D area calculations" },
        { label: "Surface Area Calculator", href: "/calculators/surface-area", description: "3D surface area calculations" },
        { label: "Metal Weight Calculator", href: "/calculators/metal-weight", description: "Metal weight estimation" },
      ]},
      { label: "Bespoke Tools", href: "/tools", description: "Design & configure custom metalwork", children: [
        { label: "Panel Configurator", href: "/tools/panel-configurator", description: "Design custom metal panels" },
        { label: "Perforation Designer", href: "/tools/perforation-designer", description: "Design perforation patterns" },
        { label: "Material Selector", href: "/tools/material-selector", description: "Guided material recommendation" },
        { label: "Finish Pairing", href: "/tools/finish-pairing", description: "Preview finish combinations" },
        { label: "Scope Builder", href: "/tools/scope-builder", description: "Build project scope documents" },
        { label: "Gauge Guide", href: "/tools/gauge-guide", description: "Metal gauge thickness reference" },
        { label: "3D Configurator", href: "/tools/3d-configurator", description: "View finishes on 3D models" },
        { label: "AR Visualizer", href: "/tools/ar-visualizer", description: "See finishes in your space" },
      ]},
      { label: "divider", divider: true },
      { label: "Project Hub", href: "/project-hub", description: "Save & organize finish mood boards" },
      { label: "Material Library", href: "/finishes", description: "25+ specialist finishes" },
      { label: "RAL Color Visualizer", href: "/color-visualizer", description: "Preview RAL colors on metal panels" },
      { label: "Electroplating Visualizer", href: "/electroplating-visualizer", description: "Select metal & preview finishes" },
      { label: "Pantone Visualizer", href: "/pantone-visualizer", description: "Complete Pantone color library" },
      { label: "Prastara Decor", href: "/prastara", description: "Decorative surfaces & textures" },
      { label: "Finish Durability Guide", href: "/finish-durability-guide", description: "Which finishes work best for your environment" },
      { label: "divider", divider: true },
      { label: "Perforated Facades Guide", href: "/guides/perforated-facades-uae-climate", description: "Engineering for UAE climate", featured: true },
    ]
  },
  { label: "Collaborate", href: "/collaborate", cta: true },
];

// Helper to get AI-generated image URLs - called at render time
const MEDIA_URL = process.env.REACT_APP_MEDIA_URL || 'https://files.ihgbrands.com/ihg-ind';
export const getAIImage = (name) => `${MEDIA_URL}/generated/${name}.webp`;

export const services = [
  {
    id: 1,
    title: "Architectural Facades",
    subtitle: "Perforated Systems \u2022 Parametric Screens \u2022 Mashrabiya \u2022 Cladding",
    description: "We design, engineer and fabricate non-glass architectural facade systems including perforated aluminum, expanded metal, CNC-patterned screens and custom cladding assemblies. Full engineering documentation with shop drawings, structural calculations and wind load compliance.",
    get image() { return getAIImage('service_facades'); },
    features: [
      "Perforated Facade Systems",
      "Parametric Metal Screens",
      "Contemporary Mashrabiya",
      "Cladding & Feature Exteriors",
      "Shop Drawings & Engineering",
      "Wind Load Compliance"
    ]
  },
  {
    id: 2,
    title: "Decorative & Interior Metal",
    subtitle: "Feature Walls \u2022 Balustrades \u2022 Ceilings \u2022 Retail Metal",
    description: "Bespoke interior metal solutions from laser-cut feature walls to sculptural staircases, suspended ceiling systems and luxury retail displays. Integrated LED channels and backlit perforations for hospitality and luxury residential projects.",
    get image() { return getAIImage('service_interiors'); },
    features: [
      "Feature Walls & Panels",
      "Staircases & Balustrades",
      "Suspended Metal Ceilings",
      "Retail & VM Metal",
      "Backlit Perforations",
      "Integrated LED Channels"
    ]
  },
  {
    id: 3,
    title: "Specialist Finishes",
    subtitle: "PVD \u2022 Electroplating \u2022 Patina \u2022 Custom Textures",
    description: "Our finishing lab delivers museum-grade surface treatments including PVD coatings, electroplating, patina applications and custom textured finishes. All finishes include durability ratings and interior/exterior suitability documentation.",
    get image() { return getAIImage('service_finishes'); },
    features: [
      "PVD Gold & Rose Gold",
      "Brass & Copper Electroplating",
      "Patina & Oxidation Effects",
      "Anti-Fingerprint Coatings",
      "Interior & Exterior Grade",
      "Custom Color Matching"
    ]
  },
  {
    id: 4,
    title: "Signage & Digital Solutions",
    subtitle: "Architectural Signage \u2022 Wayfinding \u2022 Digital Displays \u2022 Branding",
    description: "Complete signage solutions from architectural wayfinding totems to branded facade elements, monument signs and digital display integration. Custom manufacturing with in-house fabrication capabilities.",
    get image() { return getAIImage('service_cnc'); },
    features: [
      "Architectural Signage",
      "Wayfinding Systems",
      "Digital Signage Integration",
      "Monument Signs",
      "Branded Facade Elements",
      "LED Channel Letters"
    ]
  }
];

export const capabilities = [
  {
    id: 1,
    title: "Metal + Lighting",
    partner: "Integrated Division",
    description: "Integrated LED and metal systems for backlit facades, feature walls and sculptural lighting installations.",
    icon: "Lightbulb"
  },
  {
    id: 2,
    title: "Metal + Signage",
    partner: "Signage Division",
    description: "Architectural signage systems from wayfinding totems to branded facade elements and monument signs.",
    icon: "PenTool"
  },
  {
    id: 3,
    title: "Metal + Supply Chain",
    partner: "Global Sourcing",
    description: "130+ OEM/ODM partners across 13 countries. Factories in Dubai, Sharjah, India, and China.",
    icon: "Layers"
  },
  {
    id: 4,
    title: "Metal + Digital",
    partner: "Business Units",
    description: "Interactive and automated systems including digital signage, motorized screens and experience-driven installations.",
    icon: "Cpu"
  }
];

export const industries = [
  {
    id: 1,
    title: "Hospitality",
    description: "Hotels, resorts and serviced apartments with precision metalwork.",
    image: "https://files.ihgbrands.com/ihg-ind/generated/solution_hospitality.webp"
  },
  {
    id: 2,
    title: "Luxury Villas",
    description: "Private villas and palaces with bespoke metal detailing.",
    image: "https://files.ihgbrands.com/ihg-ind/generated/local_palm.webp"
  },
  {
    id: 3,
    title: "Retail & F&B",
    description: "Branded retail environments and restaurant metal features.",
    image: "https://files.ihgbrands.com/ihg-ind/generated/solution_retail.webp"
  },
  {
    id: 4,
    title: "Commercial",
    description: "Office towers, lobbies and corporate environments.",
    image: "https://files.ihgbrands.com/ihg-ind/generated/local_dubai.webp"
  },
  {
    id: 5,
    title: "Healthcare",
    description: "Hospitals, clinics and wellness centres.",
    image: "https://files.ihgbrands.com/ihg-ind/generated/gallery_healthcare_1.webp"
  }
];

export const processSteps = [
  { step: 1, title: "Concept Collaboration", description: "We engage with your design team to understand intent, material vision and project context.", icon: "MessageSquare" },
  { step: 2, title: "Design Development", description: "3D modeling, pattern development and material specification with full designer coordination.", icon: "Compass" },
  { step: 3, title: "Engineering & Detailing", description: "Shop drawings, structural calculations, wind load analysis and BIM coordination.", icon: "Ruler" },
  { step: 4, title: "Mock-Up & Sampling", description: "Physical prototypes and finish samples for designer approval before production.", icon: "Box" },
  { step: 5, title: "Fabrication", description: "CNC laser cutting, press brake forming, welding and precision assembly in our 90,000 sq.ft facility.", icon: "Wrench" },
  { step: 6, title: "Finishing", description: "Powder coating, PVD, electroplating, polishing and custom surface treatments.", icon: "Paintbrush" },
  { step: 7, title: "Installation", description: "Expert site installation with structural coordination and safety compliance.", icon: "Hammer" },
  { step: 8, title: "Quality Assurance", description: "Final inspection, documentation handover and defects liability support.", icon: "Shield" }
];

export const finishes = [
  { category: "PVD Coatings", description: "Physical Vapor Deposition for ultra-durable metallic finishes.",
    types: [{ name: "Gold", suitability: "Interior & Exterior" }, { name: "Rose Gold", suitability: "Interior" }, { name: "Bronze", suitability: "Interior & Exterior" }, { name: "Black Titanium", suitability: "Interior & Exterior" }, { name: "Champagne", suitability: "Interior & Exterior" }] },
  { category: "Electroplating", description: "Traditional plating techniques for rich metallic surfaces.",
    types: [{ name: "Brass", suitability: "Interior" }, { name: "Copper", suitability: "Interior" }, { name: "Nickel", suitability: "Interior & Exterior" }, { name: "Chrome", suitability: "Interior & Exterior" }] },
  { category: "Patina & Chemical", description: "Controlled oxidation and chemical treatments.",
    types: [{ name: "Verde Patina", suitability: "Interior & Exterior" }, { name: "Aged Bronze", suitability: "Interior" }, { name: "Rust Effect", suitability: "Interior & Exterior" }, { name: "Blackened Steel", suitability: "Interior & Exterior" }] }
];

export const projects = [
  { id: 1, title: "Al Mira Tower", location: "Dubai Marina, UAE", category: "Hospitality",
    description: "Bespoke perforated bronze facade screens with mashrabiya-inspired geometric patterns for a 5-star hotel development.",
    image: "https://files.ihgbrands.com/ihg-ind/generated/project_hotel_lobby.webp", tags: ["Facade", "Hospitality", "Bronze"] },
  { id: 2, title: "Maison Lumière Boutique", location: "City Walk, Dubai", category: "Retail",
    description: "Bespoke brass and smoked glass display systems for a premium jewellery retail environment with integrated LED lighting.",
    image: "https://files.ihgbrands.com/ihg-ind/generated/project_jewellery_retail.webp", tags: ["Retail", "Display", "Brass"] },
  { id: 3, title: "Sultan Rashid Mosque", location: "Abu Dhabi, UAE", category: "Cultural",
    description: "Modern interpretation of traditional mashrabiya screens in oxidized copper for a spiritual architectural landmark.",
    image: "https://files.ihgbrands.com/ihg-ind/generated/project_mosque.webp", tags: ["Cultural", "Mashrabiya", "Copper"] },
  { id: 4, title: "Meridian Corporate Tower", location: "DIFC, Dubai", category: "Commercial",
    description: "Dramatic floor-to-ceiling brushed stainless steel feature walls with geometric laser-cut perforations for a corporate headquarters.",
    image: "https://files.ihgbrands.com/ihg-ind/generated/project_commercial_tower.webp", tags: ["Commercial", "Feature Wall", "Stainless Steel"] },
  { id: 5, title: "Copper & Oak Bistro", location: "Downtown Dubai, UAE", category: "F&B",
    description: "Custom copper ceiling installation with flowing organic patterns and integrated warm lighting for an upscale restaurant.",
    image: "https://files.ihgbrands.com/ihg-ind/generated/project_restaurant.webp", tags: ["F&B", "Ceiling", "Copper"] },
  { id: 6, title: "Villa Serena Estate", location: "Emirates Hills, Dubai", category: "Luxury Residential",
    description: "Ornate wrought iron and bronze entrance gates with arabesque scrollwork and matching balustrade systems.",
    image: "https://files.ihgbrands.com/ihg-ind/generated/project_villa_emirates.webp", tags: ["Residential", "Gates", "Bronze"] }
];

export const contactOptions = [
  { id: 1, title: "Request Finish Samples", description: "Receive physical material and finish samples for specification review.", icon: "Palette" },
  { id: 2, title: "Technical Consultation", description: "Discuss engineering requirements, structural compliance and material selection.", icon: "FileText" },
  { id: 3, title: "Upload Your Drawings", description: "Share your design drawings for a preliminary fabrication assessment.", icon: "Upload" },
  { id: 4, title: "Book Fabrication Tour", description: "Visit our 90,000 sq.ft facility to see capabilities and quality processes.", icon: "Calendar" }
];

export const sisterCompanies = [
  { name: "IHG Brands", description: "FF&E Procurement", url: "https://ihgbrands.com" },
  { name: "Signage Division", description: "Signage & Branding", url: "https://ihgind.com/divisions/signage" },
  { name: "Lighting Division", description: "Bespoke Lighting", url: "https://ihgind.com/divisions/lighting" },
  { name: "Supply Chain", description: "Global Sourcing", url: "https://ihgind.com/divisions/supply-chain" },
  { name: "Business Units", description: "Digital & Automation", url: "https://ihgind.com/divisions/business-units" }
];

export const stats = [
  { value: "260+", label: "People" },
  { value: "18+", label: "Years Experience" },
  { value: "43", label: "Countries" },
  { value: "90K", label: "Sq.Ft Manufacturing" }
];

// Alias for backward compatibility with pages that use caseStudies
export const caseStudies = projects;

// Collaborators section data (used by CollaboratePage)
export const collaborators = [
  { slug: "architects", title: "Architects", description: "Design partners for landmark projects" },
  { slug: "interior-designers", title: "Interior Designers", description: "Collaborators in luxury spaces" },
  { slug: "artists", title: "Artists", description: "Creative visionaries we bring to life" },
  { slug: "developers", title: "Developers", description: "Strategic partners in construction" }
];

